"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isBelowMonthlyMedianIncome;

var _getStateMedianFamilyIncome = _interopRequireDefault(require("./getStateMedianFamilyIncome"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isBelowMonthlyMedianIncome(income, state, persons) {
  if (!income) throw new Error('Missing Income');
  if (!state) throw new Error('Missing State');
  var medianMonthly = (0, _getStateMedianFamilyIncome["default"])(state, persons) / 12;
  return Number(income) <= Number(medianMonthly);
}